import { ButtonBase } from '@mui/material'

import FolderName from './folder-name'
import useStyles from './index.styles'
import StatusDots from './status-dots'
import { ILocationFolder } from './types'

interface IProps {
  folder: ILocationFolder
  isSelected: boolean
  onClick: () => void
}

const FolderRow = ({ folder, isSelected, onClick }: IProps) => (
  <ButtonBase sx={useStyles.folderRow} onClick={onClick}>
    <FolderName folder={folder} isSelected={isSelected} />
    <StatusDots folder={folder} />
  </ButtonBase>
)

export default FolderRow
